import * as Yup from 'yup';
import {
  FormBlock,
  FormIsoCountryCodeField,
  FormPhoneCountryCodeField,
  FormPhoneField,
  FormTextField,
} from 'omakase';
import { Grid } from 'ui';
import { RequestSummary } from 'components/business/waitlist-dialog/RequestSummary';
import { dialogFormBlock } from 'components/business/waitlist-dialog/waitlistPreferencesFormCssDefs';

export type ContactFields = {
  firstName: string;
  lastName: string;
  email: string;
  phoneCountryCode: string;
  phone: string;
  isoCountryCode: string;
};

/**
 * Validation rules.  Phone is optional. FormPhoneField will validate
 * user input and NOT block submission.
 */
export const contactSchema: Yup.SchemaOf<ContactFields> = Yup.object({
  firstName: Yup.string().required().label('First name'),
  lastName: Yup.string().required().label('Last name'),
  email: Yup.string().required().email().label('Email'),
  phoneCountryCode: Yup.string().optional().default(''),
  phone: Yup.string().optional().default(''),
  isoCountryCode: Yup.string().required('Country'),
});

export const WaitlistContactForm = () => {
  return (
    <FormBlock showDivider={false} css={dialogFormBlock}>
      <RequestSummary />
      <FormTextField fullWidth label="First name" name="firstName" />
      <FormTextField fullWidth label="Last name" name="lastName" />
      <FormTextField fullWidth label="Email" name="email" />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <FormPhoneCountryCodeField fullWidth label="Country code" name="phoneCountryCode" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormPhoneField fullWidth label="Phone number" name="phone" />
        </Grid>
      </Grid>
      <FormIsoCountryCodeField fullWidth label="Country" name="isoCountryCode" />
    </FormBlock>
  );
};
